import { render, staticRenderFns } from "./CommunityComp.vue?vue&type=template&id=32013f14&scoped=true"
import script from "./CommunityComp.vue?vue&type=script&lang=js"
export * from "./CommunityComp.vue?vue&type=script&lang=js"
import style0 from "./CommunityComp.vue?vue&type=style&index=0&id=32013f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32013f14",
  null
  
)

/* custom blocks */
import block0 from "./CommunityComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports